import { render, staticRenderFns } from "./Campanhas.vue?vue&type=template&id=6a44fc7b&scoped=true&"
import script from "./Campanhas.vue?vue&type=script&lang=js&"
export * from "./Campanhas.vue?vue&type=script&lang=js&"
import style0 from "./Campanhas.vue?vue&type=style&index=0&id=6a44fc7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44fc7b",
  null
  
)

export default component.exports